import constants from '@/js/constants';
import useUiPlanningStore from '@/stores/ui/planning';
import usePlanningStore from '@/stores/planning/planning';
import usePlanningLanesStore from '@/stores/planning/lanes';
import useSubprojectsStore from '@/stores/subprojects';
import PlanningLane from '@/models/PlanningLane';

export default {
  data() {
    return {
      laneHeaderHeight: 0,
      resizeObserver: null,
      uiPlanningStore: useUiPlanningStore(),
      planningStore: usePlanningStore(),
      planningLanesStore: usePlanningLanesStore(),
      subprojectsStore: useSubprojectsStore(),
    };
  },
  beforeUnmount() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
  },
  computed: {
    isKanbanMode() {
      return this.uiPlanningStore.mode == 'kanban';
    },
    laneContentHeight() {
      const laneId = this.lane.id;
      let lane = this.planningLanesStore.lanesMap.get(laneId);
      let els = this.laneElements;
      if (! lane) {
        const subprojectLane = this.subprojectsStore.getLaneSubProject(laneId);
        if (! subprojectLane || ! subprojectLane.lane) return 0;
        lane = subprojectLane.lane;
        els = this.planningLanesStore.getLaneElements({ planning: subprojectLane.planning, laneId });
      }
      if (lane.hidden) {
        lane.contentHeight = constants.hiddenLaneHeight;
        this.lane.contentHeight = lane.contentHeight;
        return this.lane.contentHeight;
      }
      const minheight = this.planningStore.planning.lanes.length > 1 ? constants.laneMinHeight : 3 * constants.laneMinHeight; // default min value / tripled when only lane
      let height = 0;
      els = els.filter(el => el.isVisibleOnPlanning() && el.height);
      if (! els.length) { // lane empty
        height = minheight;
      } else {
        const yPositions = PlanningLane.getAllYposition(els);
        els.forEach((el) => {
          _.extend(el, yPositions.get(el.id));
        });
        height = Math.max.apply(null, els.map(o => (o.yposition || 0) + (o.height || 0)));
      }
      lane.contentHeight = Math.ceil(Math.max(minheight, height) + constants.lanePadding + 1);
      this.lane.contentHeight = lane.contentHeight;
      return this.lane.contentHeight;
    },
    laneHeight() {
      if (! this.laneHeaderHeight) this.updateLaneHeaderHeight();
      this.lane.height = Math.max(this.laneContentHeight, this.laneHeaderHeight);
      return this.lane.height;
    },
    kanbanLaneHeaderMinHeight() {
      const laneMinHeight = constants.laneMinHeight + constants.lanePadding + 1;
      return Math.max(laneMinHeight, this.laneHeaderHeight);
    },
    laneHeaderHeightReactiveProperties() {
      return { label: this.lane.label, hidden: this.lane.hidden };
    },
  },
  watch: {
    laneHeaderHeightReactiveProperties: {
      handler() { this.updateLaneHeaderHeight(); },
      deep: true,
    },
  },
  methods: {
    updateLaneHeaderHeight() {
      this.$nextTick(() => {
        this.laneHeaderHeight = this.planningLanesStore.getLaneHeaderHeight(this.lane.id);
      });
    },
    createLaneHeightObserver() {
      if (! this.laneHeaderHeight) this.updateLaneHeaderHeight();
      const laneContent = document.getElementById(`lane${this.lane.id}`);
      if (! laneContent) return;
      this.resizeObserver = new ResizeObserver(() => {
        if (this.isKanbanMode) {
          this.lane.height = laneContent.offsetHeight;
        }
      });
      this.resizeObserver.observe(laneContent);
    },
  },
};
